import { CookiesProvider } from 'react-cookie';
import './App.css';
import UI from './ui';
import { ModeProvider } from './context/ModeContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient()

function App() {

  return (
    <QueryClientProvider client={queryClient}>
      <CookiesProvider>
        <ModeProvider>
          <UI></UI>
        </ModeProvider>
      </CookiesProvider>
    </QueryClientProvider>
  )

  // return (
  //   <AuthProvider>
  //     <BrowserRouter>
  //       <Routes>
  //         <Route path='/' element={<LoginPage />} />
  //         <Route path='menu' element={<RequireAuth><Menu /></RequireAuth>} />
  //         <Route path='create' element={<RequireAuth><div>create</div></RequireAuth>} />
  //         <Route path='delete' element={<RequireAuth><div>delete</div></RequireAuth>} />
  //         <Route path='find' element={<RequireAuth><Find /></RequireAuth>} />
  //         <Route path='*' element={<div>not found</div>} />
  //       </Routes>
  //     </BrowserRouter>
  //   </AuthProvider>
  // )
}

export default App;
